import { render } from "./Paginate.vue?vue&type=template&id=435cd222&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=435cd222&lang=css&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435cd222"]])

export default __exports__